import { makeStyles } from '@material-ui/core/styles';
import city from '../../img/city.jpg';


const contactClasses = makeStyles((theme) => ({
  contactInformation: {
    textAlign: 'right',
    [theme.breakpoints.down('sm')]: {
      textAlign: 'left',
    },
  },

  cityImg: {
    backgroundImage:`url(${city})`,
    backgroundRepeat: 'no-repeat',
    backgroundColor:
    theme.palette.type === 'light' ? theme.palette.grey[50] : theme.palette.grey[900],
      backgroundSize: 'cover',
      backgroundPosition: 'center',
      minHeight:400,
      borderRadius: 30,
      padding: 0,
    },

    iconSuccess: {
      fontSize: '3rem',
      color: '#A4C1C8',
      padding: '10px 0 30px 0',
    },

    dialogBoxSuccess: {
      margin: '0 auto',
      textAlign: 'center',
    }
}));

export default contactClasses